import React, { useState } from "react";
import styled from "styled-components";
import { BackgroundImage } from "../../authentication/shared/SharedStyles";
import { colors } from "../../../styles/style";
import goBackIcon from "../../../images/goBackIcon.svg";
import Button from "../../../helpers/components/Button";
import { useNavigate } from "react-router-dom";
import clouds from "../../../images/clouds.svg";
import {
  Option,
  FlexRowBetweenCenter,
  BigHeaderText,
  SwitchContainer,
  MediumIcon,
} from "../../shared/SharedStyles";
import SwipeableViews from "react-swipeable-views";
import { MonthlyDiaryList } from "./common/MonthlyDiaryList";
import { MilestoneButtonWrapper } from "../common/SharedComponents";

export const MonthlyDiary = () => {
  const startYear = 2020;
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) =>
    (startYear + i).toString()
  );
  const [selectedYear, setSelectedYear] = useState<string>(
    currentYear.toString()
  );
  const navigate = useNavigate();
  const yearGroupsCount = Math.ceil(years.length / 3);
  const initialYearGroupIndex = yearGroupsCount - 1;
  const [yearGroupIndex, setYearGroupIndex] = useState<number>(
    initialYearGroupIndex
  );

  // Helper function to get years for a specific group
  // Groups from the end so the last group always has the most recent 3 years
  const getYearsForGroup = (groupIndex: number): string[] => {
    const remainder = years.length % 3 || 3;
    if (groupIndex === 0 && remainder !== 3) {
      return years.slice(0, remainder);
    }
    const adjustedIndex = remainder === 3 ? groupIndex : groupIndex - 1;
    const startIndex = remainder + adjustedIndex * 3;
    return years.slice(startIndex, startIndex + 3);
  };

  const goBackHandler = () => {
    navigate(-1);
  };

  return (
    <React.Fragment>
      <Container>
        <BackgroundImage
          $blend_mode=""
          $position="absolute"
          $left="0"
          $top="0"
          $transform="translate(-50%, -50%)"
          $width="390px"
          alt="Frame"
          src={clouds}
        />
        <HeaderContainer>
          <MediumIcon src={goBackIcon} onClick={goBackHandler} />
          <BigHeaderText>Monthly Diary</BigHeaderText>
          <div></div>
        </HeaderContainer>
        <SwitchContainer>
          <SwipeableViews
            index={yearGroupIndex}
            onChangeIndex={setYearGroupIndex}
          >
            {Array.from({ length: yearGroupsCount }, (_, index) => (
              <YearGroup key={index}>
                {getYearsForGroup(index).map((year) => (
                  <Option
                    key={year}
                    $active={selectedYear === year ? "true" : "false"}
                    onClick={() => setSelectedYear(year)}
                  >
                    {year}
                  </Option>
                ))}
              </YearGroup>
            ))}
          </SwipeableViews>
        </SwitchContainer>

        <MonthlyDiaryList selectedYear={selectedYear} />
        <MilestoneButtonWrapper>
          <Button $button_type="colored" onClick={goBackHandler}>
            Go Back
          </Button>
        </MilestoneButtonWrapper>
      </Container>
    </React.Fragment>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  min-height: 100vh;
  padding-top: 40px;
  background-color: ${colors.bgWhite};
`;

const HeaderContainer = styled.div`
  ${FlexRowBetweenCenter}
  padding: 16px;
  width: 100%;
`;

const YearGroup = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;
